import { motion } from "framer-motion";

const ease = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "", ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, ease, delay }}
    {...rest}
  >
    {children}
  </motion.div>
);

export const SplitLines = ({ lines, className = "", delay = 0, stagger = 0.12, as: Tag = "h1" }) => (
  <Tag className={className}>
    {lines.map((line, i) => (
      <span key={i} className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
        <motion.span
          className="block"
          initial={{ y: "110%" }}
          animate={{ y: 0 }}
          transition={{ duration: 0.9, ease, delay: delay + i * stagger }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </Tag>
);

export const Eyebrow = ({ children, className = "", dark = false }) => (
  <span
    className={`inline-flex items-center gap-3 text-[11px] font-semibold uppercase tracking-[0.22em] ${
      dark ? "text-white/60" : "text-ink/55"
    } ${className}`}
  >
    <span className={`h-px w-8 ${dark ? "bg-red" : "bg-red"}`} />
    {children}
  </span>
);
